import { auth } from '../firebase';

// fetch() for the tournament tools that live on plain HTTP endpoints rather
// than callables. Those endpoints verify a Firebase ID token now
// (requireHttpRole in functions/index.js), so every call has to carry one —
// they used to be reachable by anyone with the URL.
//
// getIdToken() refreshes on its own when the token is close to expiry, so this
// is safe to call per request. No signed-in user means no header, and the
// server answers 401 rather than the page failing in some other way.
export async function authedFetch(url, options = {}) {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
